import React, { useId } from "react";

// The Gatherly mark: three guests gathered on top of a "G". Rendered inline
// so it stays crisp at any size and needs no image asset.
export function LogoMark({ size = 36 }) {
  const id = useId();
  return (
    <svg className="logo__mark" width={size} height={size} viewBox="0 0 100 100" aria-hidden="true">
      <defs>
        <linearGradient id={`${id}p`} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#e91e7a" />
          <stop offset="1" stopColor="#ff5a5f" />
        </linearGradient>
        <linearGradient id={`${id}b`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#0d1b5e" />
          <stop offset="1" stopColor="#2563eb" />
        </linearGradient>
      </defs>
      <g fill="none" strokeLinecap="round" strokeWidth="13">
        <path d="M30.7 37A30 30 0 0 0 39.7 88.2" stroke={`url(#${id}p)`} />
        <path d="M65 34A30 30 0 0 1 76 45" stroke="#7b2ff7" strokeWidth="10" />
        <path d="M20.5 65.2A30 30 0 0 0 80 60H54" stroke={`url(#${id}b)`} strokeLinejoin="round" />
      </g>
      <path d="M37 40a13 13 0 0 1 26 0q-13-6-26 0z" fill="#ff9500" />
      <circle cx="29" cy="22" r="6.5" fill="#e91e7a" />
      <circle cx="50" cy="15" r="7.5" fill="#ff9500" />
      <circle cx="70" cy="21" r="6.5" fill="#7b2ff7" />
    </svg>
  );
}

export default function Logo({ size = 36, light = false }) {
  return (
    <span className={`logo${light ? " logo--light" : ""}`} role="img" aria-label="Gatherly">
      <LogoMark size={size} />
      <span className="logo__word" style={{ fontSize: size * 0.72 }} aria-hidden="true">
        atherly
      </span>
    </span>
  );
}
